/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StocktakeInputs */

const vi_nav_stocktake = /** @type {(inputs: Nav_StocktakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm kê`)
};

/**

* @param {Nav_StocktakeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_stocktake = /** @type {((inputs?: Nav_StocktakeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StocktakeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_stocktake(inputs)
});